import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { useAuth } from './AuthContext';
import { supabase } from '../lib/supabase';


export interface ClassOption { id: string; name: string; grade_level: number; }

interface ClassesContextType {
  classes: ClassOption[];
  loading: boolean;
  refreshClasses: () => Promise<void>;
}

const ClassesContext = createContext<ClassesContextType>({ classes: [], loading: false, refreshClasses: async () => {} });

export function ClassesProvider({ children }: { children: React.ReactNode }) {
  const { school } = useAuth();
  const [classes, setClasses] = useState<ClassOption[]>([]);
  const [loading, setLoading] = useState(false);

  const refreshClasses = useCallback(async () => {
    if (!school?.id) return;
    setLoading(true);
    const { data } = await supabase
      .from('classes')
      .select('id, name, grade_level')
      .eq('school_id', school.id)
      .eq('is_active', true)
      .order('sort_order');
    setClasses(data || []);
    setLoading(false);
  }, [school?.id]);

  useEffect(() => { refreshClasses(); }, [refreshClasses]);

  return (
    <ClassesContext.Provider value={{ classes, loading, refreshClasses }}>
      {children}
    </ClassesContext.Provider>
  );
}

export function useClasses() {
  return useContext(ClassesContext);
}